import { FeatureFlagProvider } from './context/FeatureFlagContext';
import Main from './main';

export default function App(): JSX.Element {
  return (
    <FeatureFlagProvider>
      <Main />
    </FeatureFlagProvider>
  );
}
